import { render, staticRenderFns } from "./jilinCourseList.vue?vue&type=template&id=f9617eee"
import script from "./jilinCourseList.vue?vue&type=script&lang=js"
export * from "./jilinCourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports